// src/app/shared/markdown/prism-genius.ts
// Prism plugin: add extra token categories for a more “ChatGPT-like” look.

export function initPrismGenius(Prism: any): void {
    if (!Prism || (Prism as any).__geniusNoirInited) return;
    (Prism as any).__geniusNoirInited = true;
  
    // Safely extend TS/JS grammars if present
    const patchTsLike = (langId: 'typescript' | 'javascript') => {
      const lang = Prism.languages?.[langId];
      if (!lang) return;
  
      // Insert BEFORE "function" token if possible so we capture "this.foo(" early
      try {
        Prism.languages.insertBefore(langId, 'function', {
          // this.someMethod(
          'instance-method': {
            pattern: /\bthis\.[_$a-zA-Z][_$\w]*(?=\s*\()/,
            inside: {
              keyword: /\bthis\b/,
              punctuation: /\./,
              function: /[_$a-zA-Z][_$\w]*/
            }
          },
  
          // this.someProp
          'instance-variable': {
            pattern: /\bthis\.[_$a-zA-Z][_$\w]*\b/,
            inside: {
              keyword: /\bthis\b/,
              punctuation: /\./,
              variable: /[_$a-zA-Z][_$\w]*/
            }
          }
        });
      } catch {
        // If insertBefore fails for any reason, just ignore—base Prism still works.
      }
    };
  
    patchTsLike('typescript');
    patchTsLike('javascript');
  
    // Hook: make "return" extra obvious (comedy punchline emphasis for code)
    Prism.hooks.add('wrap', (env: any) => {
      if (env?.type === 'keyword' && env?.content === 'return') {
        env.classes.push('keyword-return');
      }
    });
  }
  